import React, { memo, useState, useImperativeHandle, forwardRef } from 'react'
import type { CustomCellEditorProps } from 'ag-grid-react'
import ScenarioCascader from '../../../../../features/scenario/components/cascader/ScenarioCascader'
import './ScenarioCascaderEditor.css'

interface ScenarioCascaderEditorParams {
  companyId?: string
}

/**
 * Custom Scenario Cascader Cell Editor
 *
 * Provides a cascader editor for selecting scenarios in AG Grid cells
 * Requires companyId in cellEditorParams
 */
const ScenarioCascaderEditor = memo(
  forwardRef<any, CustomCellEditorProps<any, any>>(({ value, onValueChange, stopEditing, column }, ref) => {
    const [currentValue, setCurrentValue] = useState(value)

    // Get companyId from cellEditorParams
    const params = (column?.getColDef()?.cellEditorParams || {}) as ScenarioCascaderEditorParams
    const { companyId } = params

    const handleChange = (newValue: any) => {
      setCurrentValue(newValue)
      onValueChange(newValue)
      stopEditing()
    }

    useImperativeHandle(ref, () => ({
      getValue: () => currentValue
    }))

    return (
      <ScenarioCascader
        companyId={companyId}
        value={currentValue}
        onChange={handleChange}
        allowClear
        style={{ width: '100%', height: '100%' }}
        className="scenario-cascader-editor"
        disabled={false}
      />
    )
  })
)

ScenarioCascaderEditor.displayName = 'ScenarioCascaderEditor'

export default ScenarioCascaderEditor
